import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prohibit",
  "use": "icon-prohibit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-prohibit\"><path d=\"M506.5 168.8c-188.5 0-341.3 152.8-341.3 341.3s152.8 341.3 341.3 341.3 341.3-152.8 341.3-341.3-152.8-341.3-341.3-341.3z m-403.4 341.3c0-222.8 180.6-403.4 403.4-403.4s403.4 180.6 403.4 403.4-180.6 403.4-403.4 403.4-403.4-180.6-403.4-403.4z\" p-id=\"476\" /><path d=\"M221.2 224.9a31 31 0 0 1 43.9 0l526.6 526.6a31 31 0 0 1-43.9 43.9L221.3 268.8a31 31 0 0 1 0-43.9z\" p-id=\"477\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol